import CreateAxiosInstance from './axiosConfig';

// Backend MCP-connector consent + guest-upgrade endpoints. Mounted at the API
// root (/mcp/consent/*, /user/merge_guest), same base URL as other services.
const APIClient = CreateAxiosInstance(import.meta.env.VITE_API_BASE_URL);

// localStorage key holding the guest's signed upgrade token, stashed by the /connect
// consent page so a later sign-in (anywhere in the app) can link the guest's resources.
export const GUEST_UPGRADE_TOKEN_KEY = 'diffit_mcp_guest_upgrade';

// Mint an anonymous guest (or reuse this browser's prior guest via its stored upgrade
// token) and get the Claude redirect URL to send the browser to.
export async function consentGuest(txn, upgradeToken = null) {
  return await APIClient.post(
    '/mcp/consent/guest',
    { txn, upgrade_token: upgradeToken },
    { customErrorHandler: () => {} }
  );
}

// Authorize as the signed-in user. The Clerk session JWT is sent in the body so
// the (auth-free) consent endpoint can verify it and find-or-create the user.
export async function consentClerk(txn, token) {
  return await APIClient.post(
    '/mcp/consent/clerk',
    { txn, token },
    { customErrorHandler: () => {} }
  );
}

// Link a guest's packets to the signed-in account (auth header added by axios).
export async function mergeGuest(upgradeToken) {
  return await APIClient.post(
    '/user/merge_guest',
    { upgrade_token: upgradeToken },
    { customErrorHandler: () => {} }
  );
}
